import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel } from '@mui/material';

const OPCOES: Array<{ letra: 'D' | 'L' | 'C'; rotulo: string; descricao: string }> = [
  { letra: 'D', rotulo: 'Delivery', descricao: 'Pedido entregue no endereço do cliente' },
  { letra: 'L', rotulo: 'Retirar no local', descricao: 'Cliente busca o pedido pronto na loja' },
  { letra: 'C', rotulo: 'Consumir no local', descricao: 'Pedido consumido na própria loja (mesa/comanda)' },
];

/** Mantém ordem canônica `DLC` independente da ordem de clique. */
function normalizar(s: string): string {
  return OPCOES.map((o) => o.letra)
    .filter((l) => s.toUpperCase().includes(l))
    .join('');
}

interface Props {
  valor: string;
  onChange: (novoValor: string) => void;
  helperText?: string;
}

/**
 * Checkboxes pra escolher as formas de retirada da loja. Persiste o estado
 * como string concatenada (ex.: `"DLC"`) — formato esperado pelo backend
 * (`configuracao_cardapio.forma_retirada`).
 */
export function FormaRetiradaCheckbox({ valor, onChange, helperText }: Props): JSX.Element {
  function toggle(letra: 'D' | 'L' | 'C'): void {
    const atual = valor.toUpperCase();
    const proximo = atual.includes(letra) ? atual.replace(letra, '') : atual + letra;
    onChange(normalizar(proximo));
  }

  return (
    <FormControl component="fieldset" fullWidth>
      <FormLabel component="legend" sx={{ mb: 1 }}>
        Formas de retirada
      </FormLabel>
      <FormGroup sx={{ gap: 1 }}>
        {OPCOES.map((o) => (
          <FormControlLabel
            key={o.letra}
            control={
              <Checkbox checked={valor.toUpperCase().includes(o.letra)} onChange={() => toggle(o.letra)} />
            }
            label={
              <span>
                {o.rotulo}{' '}
                <span style={{ opacity: 0.6, fontSize: 12 }}>— {o.descricao}</span>
              </span>
            }
            sx={{ ml: 0, '& .MuiFormControlLabel-label': { ml: 0.5 } }}
          />
        ))}
      </FormGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
